module.exports = __webpack_public_path__ + "04_very_short_brown.1ae1d22d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/boy/layer5/04_very_short_brown.png
// module id = 9lc1
// module chunks = 0